import { QueryClient } from '@tanstack/react-query';
import { isForbiddenError, isUnauthenticatedError } from '~/framework/bff';

export function initQueryClient(): QueryClient {
   return new QueryClient({
      defaultOptions: {
         queries: {
            staleTime: 10000,
            retry: false,
            useErrorBoundary(error) {
               return isUnauthenticatedError(error) || isForbiddenError(error);
            },
         },
         mutations: {
            useErrorBoundary(error) {
               return isUnauthenticatedError(error);
            },
         },
      },
   });
}
